import { render, staticRenderFns } from "./SpeedStatsItem.vue?vue&type=template&id=4adb230f&scoped=true&"
import script from "./SpeedStatsItem.vue?vue&type=script&lang=js&"
export * from "./SpeedStatsItem.vue?vue&type=script&lang=js&"
import style0 from "./SpeedStatsItem.vue?vue&type=style&index=0&id=4adb230f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb230f",
  null
  
)

export default component.exports